import React from "react";

const Filter2LineIcon = () => (
	<g>
		<path d='M14 14V20L10 22V14L4 5V3H20V5L14 14ZM6.4037 5L12 13.3944L17.5963 5H6.4037Z' />
	</g>
);

export default Filter2LineIcon;
